import React from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useNotify } from "../../context/NotifyContext";

/**
 * Inline copyable value for important listing cells (txn id, account, etc.).
 */
const CopyText = ({ value, label, className = "" }) => {
  const { notify } = useNotify();
  const text = value == null || value === "" ? "" : String(value);

  const handleCopy = async (e) => {
    e.stopPropagation();
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      notify(label ? `${label} copied` : "Copied", "success");
    } catch {
      notify("Copy failed", "error");
    }
  };

  if (!text) return <span className="text-[var(--text-muted)]">—</span>;

  return (
    <span className={`ds-copy-cell ${className}`}>
      <span className="ds-copy-cell__text" title={text}>
        {text}
      </span>
      <button
        type="button"
        className="ds-copy-btn"
        onClick={handleCopy}
        aria-label="Copy"
        title="Copy"
      >
        <ContentCopyIcon sx={{ fontSize: 14 }} />
      </button>
    </span>
  );
};

export default CopyText;
